import React from 'react';
import { Box, Divider } from '@mui/material';

export default function EmptyContainer() {
  return (
    <Box sx={{ width: '100%', bgcolor: '#0a0a0a' }}>
       <Divider sx={{ borderColor: '#222', width: '80%', mx: 'auto' }} />
    </Box>
  )
}